module.exports = __webpack_public_path__ + "static/media/Vector.ddc63ce4.svg";